/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.build-view--with-lhr-base-link-hover .lhr-comparison__scores-and-dropdowns .dropdown--base-url,
.build-view--with-lhr-compare-link-hover .lhr-comparison__scores-and-dropdowns .dropdown--compare-url {
  background: var(--compare-secondary-highlight-color);
}

.build-view--with-lhr-base-link-hover
  .lhr-comparison__scores-and-dropdowns
  .dropdown--base-url
  .dropdown__label,
.build-view--with-lhr-compare-link-hover
  .lhr-comparison__scores-and-dropdowns
  .dropdown--compare-url
  .dropdown__label {
  padding-left: calc(var(--base-spacing) / 4);
  margin-right: calc(var(--base-spacing) / 4);
}
